import React, {useEffect, useState} from "react";
import styles from "./Artigos.modules.css";
import Navbar from "../../utils/components/navbar/Navbar";
import ResumoArtigo from "../../utils/components/resumoArtigo/ResumoArtigo";
import Footer from "../../utils/components/footer/Footer";
import {getAllArticles} from "../../utils/backend/methods";
import {toast} from "react-toastify";
import {formatDate} from "../../utils/globals";

const Artigos = () => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        getAllArticles().then((response) => {
            setArticles(response.data);
        }).catch((error) => {
            console.log(error);
            toast.error("Erro ao carregar artigos");
        })
    }, []);

    return(
        <>
            <Navbar minimal={false}/>
            <div className="container min-vh-100">
                {articles && articles.reduce((rows, article, index) => {
                    if (index % 2 === 0) {
                        rows.push([article]);
                    } else {
                        rows[rows.length - 1].push(article);
                    }
                    return rows;
                }, []).map((row, rowIndex) => (
                    <div className="row" key={rowIndex}>
                        {row.map((article) => (
                            <div className="col-md-6 col-lg-6 d-flex justify-content-center p-0" key={article.id}>
                                <ResumoArtigo
                                    titulo={article.title}
                                    data={formatDate(article.updated_at)}
                                    markdown={article.content}
                                    author={article.author.name}
                                    id={article.id}
                                />
                            </div>
                        ))}
                    </div>
                ))}
            </div>

            <Footer/>
        </>
    )
}

export default Artigos;